export default __webpack_public_path__ + "static/newsletter_cover-f4947ae9c42eec597100fc274ec9b4c8.jpg";